import { render, staticRenderFns } from "./accordian.vue?vue&type=template&id=3a2b4720&"
import script from "./accordian.vue?vue&type=script&lang=js&"
export * from "./accordian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/components/kirbyimage.vue').default,Kirbylink: require('/opt/build/repo/components/kirbylink.vue').default})
